import { render, staticRenderFns } from "./CreateTag.vue?vue&type=template&id=1bd5d3b7&scoped=true"
import script from "./CreateTag.vue?vue&type=script&lang=js"
export * from "./CreateTag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bd5d3b7",
  null
  
)

export default component.exports